import { render, staticRenderFns } from "./presentationItem.vue?vue&type=template&id=980e50a8&scoped=true&"
import script from "./presentationItem.vue?vue&type=script&lang=js&"
export * from "./presentationItem.vue?vue&type=script&lang=js&"
import style0 from "./presentationItem.vue?vue&type=style&index=0&id=980e50a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980e50a8",
  null
  
)

export default component.exports